module.exports = __webpack_public_path__ + "media/assets/fonts/Montserrat-Regular-65bc44fbf8204991497c838486ec83e2.otf";